import { render } from "./checkprobelong.vue?vue&type=template&id=ac8f6df4"
import script from "./checkprobelong.vue?vue&type=script&lang=js"
export * from "./checkprobelong.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__